<script setup lang="ts">
import type { ProductLineDetail } from '~/types/api'

const props = defineProps<{
  line: ProductLineDetail
}>()

const { getResourceUrl } = useResources()

const backgroundImages = computed(() => {
  // there must be at least 3 slides for loop to work, have to duplicate images
  const minLength = 3
  const originalImages = props.line.backgroundImages
  const imageCount = originalImages.length

  if (originalImages && imageCount >= minLength) {
    return originalImages
  }

  if (imageCount === 0) {
    return []
  }

  const images = []
  for (let i = 0; i < minLength; i++) {
    images.push(originalImages[i % imageCount])
  }
  return images
})
</script>

<template>
  <div v-if="line" class="relative">
    <UiCarousel
      :opts="{ loop: true, align: 'center', containScroll: false }"
      class="w-full @container"
    >
      <UiCarouselPrevious class="group absolute left-2 top-1/2 z-10 text-white">
        <Icon size="30" name="bi:arrow-left" class="group-disabled:hidden" />
      </UiCarouselPrevious>
      <UiCarouselContent class="h-full">
        <UiCarouselItem
          v-for="image in backgroundImages"
          :key="image.nid"
          class="@5xl:container @4xl:px-2"
        >
          <div class="h-[520px] w-full overflow-hidden lg:h-[720px]">
            <img
              class="h-full w-full object-cover object-bottom"
              :src="getResourceUrl(image.url + '/1920x1920/FIT')"
              :alt="image?.metaAlt ?? undefined"
              :title="image?.metaTitle ?? undefined"
              loading="lazy"
            />
          </div>
        </UiCarouselItem>
      </UiCarouselContent>
      <UiCarouselNext class="group absolute right-2 top-1/2 z-10 text-white">
        <Icon size="30" name="bi:arrow-right" class="group-disabled:hidden" />
      </UiCarouselNext>
    </UiCarousel>
  </div>
</template>

<style>
.line-carousel .tns-item {
  @apply md:px-3;
}

.line-carousel .tns-inner {
  @apply md:!mx-20;
}
</style>
